import { HttpClient } from '@wix/http-client';

const isSSR = typeof window === 'undefined';

const httpClient = new HttpClient({ isSSR, timeout: 10000 });

export { httpClient };
